import { createRouteRef } from '@backstage/frontend-plugin-api';

export const appsMonitorRouteRef = createRouteRef();
